import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-add-marche",
  templateUrl: "./add-marche.component.html",
  styleUrls: ["./add-marche.component.scss"],
})
export class AddMarcheComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
